import React from 'react';
import { Clock, User } from 'lucide-react';

const EmptyState = ({ activeTab, onNewRetard }) => {
  return (
    <div className="text-center py-16 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="mx-auto h-20 w-20 rounded-full bg-white shadow-lg flex items-center justify-center mb-4">
        <Clock className="h-10 w-10 text-gray-400" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        Aucun retard enregistré
      </h3>
      <p className="text-gray-600 mb-6 max-w-md mx-auto">
        Commencez par ajouter un nouveau retard {activeTab === 'etudiants' ? 'étudiant' : 'enseignant'} 
        pour commencer le suivi.
      </p>
      <button
        onClick={onNewRetard}
        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-[#202654] to-[#2a2f6c] hover:from-[#1a1f4a] hover:to-[#242862] transition-all duration-200 transform hover:scale-105"
      >
        <User className="h-5 w-5 mr-2" />
        Nouveau Retard
      </button>
    </div>
  );
};

export default EmptyState; 